import React, { PropsWithChildren } from 'react';
import { ThemeProvider as MUITheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { createThemeYH } from '@cp/ds';
import { Global } from '@emotion/react';
import { ContainerCssTokens, TypographyCssTokens } from '@cp/ui';
import { ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { themeNameSelector } from './reducer';

export const ThemeProvider = (
  props: PropsWithChildren<{
    ssrMatchMedia?: (query: string) => {
      matches: boolean;
    };
  }>,
) => {
  const themeName = useSelector(themeNameSelector);
  const theme = React.useMemo(() => createThemeYH(themeName, { ssrMatchMedia: props.ssrMatchMedia }), [props.ssrMatchMedia, themeName]);
  return (
    <MUITheme theme={theme}>
      <Global
        styles={{
          ':root': {
            [TypographyCssTokens.accentColor]: theme.palette['brand pink'],
            [ContainerCssTokens.offset]: theme.spacing(1.5),
            [ModalLayoutTokens.Radius]: `${theme.borderRadius.large}px`,
          },
          [theme.breakpoints.up('md')]: {
            ':root': {
              [ContainerCssTokens.offset]: theme.spacing(4),
              [ContainerCssTokens.width]: '900px',
              [ModalLayoutTokens.Radius]: `${theme.borderRadius.extraLarge}px`,
              [ModalLayoutTokens.ContainerWidth]: '415px',
            },
          },
          [theme.breakpoints.up('lg')]: {
            ':root': {
              [ContainerCssTokens.width]: '1200px',
            },
          },
        }}
      />
      {props.children}
    </MUITheme>
  );
};
